<template>
  <el-container id="common-panel">
    <!-- 上面能源类型选择 -->
    <el-row v-if="panelData.hasMenu" style="width: 100%; height: 48px;margin-bottom: 1px;background-color: #ffffff;">
      <el-menu default-active="1" class="horizontal-menu" @select="menuSelect"
               mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(1, 1, 1, 1)">
        <template v-for="sub in panelData.energyItem">
          <el-menu-item class="horizontal-menu-item" :key="sub.id" :index="sub.id">
            <span style="font-size: 14px;">{{sub.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-row>
    <el-row class="inner-part" :style="{height: panelData.hasMenu ? '' : '100%'}">
      <!-- 左侧树区域 设置hasTree为true时显示 -->
      <el-aside :class="getPanelAsideClass()" v-if="panelData.hasTree" width="250px" style="background-color: #ffffff;margin-right: 1px;overflow: hidden;">
        <!-- 树标题区域 -->
        <!-- 树上方工具区域 搜索栏为默认存在 若包含工具按钮需设置hasTreeToolbar为true-->
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <!-- 树区域 -->
        <el-tree
                 :data="treeData" :filter-node-method="filterNode"
                 :props="panelData.treeProps" @check-change="handleCheckChange" :default-checked-keys="checkedKey"
                 :node-key="(panelData.methods && panelData.methods.query_id)?panelData.methods.query_id:'id'"
                 ref="tree" @node-click="handleNodeClick"
                 :default-expanded-keys="expandKeys" highlight-current class="aside-tree">
          <span slot-scope="{ node, data }">
            <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
            <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
            <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
            {{ node.label }}
          </span>
        </el-tree>
      </el-aside>

      <!-- 主功能区域 -->
      <el-main :class="getPanelMainClass()" :style="getPanelMainStyle()">
      <!-- 筛选按钮区域 -->
      <el-col v-if="showFilterBar" class="doc-filter-bar">
        <el-col v-for="filter in panelData.filterForm" :key="filter.label" :style="getFilterBarStyle()">
          <span v-if="filter.type !== '' && filter.label !== ''" style="width: fit-content;white-space: nowrap;font-size: 14px;margin-left: 24px;">{{filter.label}}</span>
          <el-button v-else-if="filter.type === 'button'" v-show="!filter.isHide" class="search-btn" :style="getFilterButtonStyle()" :icon="filter.icon" @click="btnClick(filter.clickMethod)">{{filter.label}}</el-button>
          <el-input v-if="filter.type === 'input'" v-model.trim="filter.value" :style="filter.style" :class="getFilterInputClass()" @keypress.native="onKeyPress" @keyup.native="inputChange($event, filter.value)"/>
          <span v-else-if="filter.type === 'label'" :style="filter.style"> {{filter.value}} </span>
          <el-select v-else-if="filter.type.indexOf('select') > -1" v-model="filter.value" :style="filter.style" :class="getFilterInputClass()"
                     @change="filter.changeBack?filter.changeBack(filter.value):doQuery(true)" filterable
                     :clearable="filter.hasOwnProperty('clearable')?filter.clearable:true">
            <el-option v-for="op in filter.options" :style='op.style' :key="op[filter.props.value]" :value="op[filter.props.value]" :label="op[filter.props.label]"/>
          </el-select>
          <el-checkbox-group v-else-if="filter.type.indexOf('checkBtn') > -1" v-model="filter.value" :style="filter.style" :class="getFilterInputClass()"
                             @change="handleCheckAllChange(value,filter.method)" size="small">
            <el-checkbox-button v-for="op in filter.options" :label="op[filter.props.value]" :key="op[filter.props.value]">{{op[filter.props.label]}}</el-checkbox-button>
          </el-checkbox-group>
          <el-checkbox-group v-else-if="filter.type.indexOf('check') > -1" v-model="filter.value" :style="filter.style" :class="getFilterInputClass()"
                             @change="handleCheckAllChange(value,filter.method)">
            <el-checkbox v-for="op in filter.options" :key="op.value" :label="op.value">{{op.label}}</el-checkbox>
          </el-checkbox-group>
          <el-radio-group v-else-if="filter.type.indexOf('radioBtn') > -1" v-model="filter.value" :style="filter.style" :class="getFilterInputClass()"
                          @change="filter.changeBack?filter.changeBack(filter.value):doQuery(true)" size="small">
            <el-radio-button v-for="op in filter.options" :label="op[filter.props.value]" :key="op[filter.props.value]">{{op[filter.props.label]}}</el-radio-button>
          </el-radio-group>
          <el-date-picker v-else-if="filter.type === 'conditionDate'" v-show="filter.isShow" :clearable="false" :class="getFilterInputClass()"
                          v-model="filter.value" :style="filter.style" value-format="yyyy-MM-dd"/>
          <el-date-picker v-else-if="filter.type === 'date'" v-model="filter.value" :style="filter.style" :class="getFilterInputClass()"
                          placeholder="选择日期" :value-format="filter.format?filter.format:'yyyy-MM-dd'" @change="filter.change" :clearable="false"/>
          <el-date-picker v-else-if="filter.type === 'month'" v-model="filter.value" :style="filter.style" :class="getFilterInputClass()"
                          type="month" placeholder="选择月份" :value-format="filter.format?filter.format:'yyyy-MM'" @change="filter.change" :clearable="false"/>
          <el-date-picker v-else-if="filter.type === 'year'" v-model="filter.value" type="year" :style="filter.style" :class="getFilterInputClass()" placeholder="选择年份" :clearable="false" />
          <el-date-picker v-else-if="filter.type === 'datetime'" v-model="filter.value" :style="filter.style" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间"></el-date-picker>
          <el-date-picker v-else-if="filter.type === 'date_range'" v-model="filter.value" type="daterange"
                          :class="getFilterInputClass()" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="filter.backHandle"/>
          <el-time-select v-else-if="filter.type === 'time'" v-model="filter.value" :style="filter.style" :class="getFilterInputClass()"
                          :picker-options="{start: '08:30',step: '00:15',end: '18:30'}" />
          <el-cascader v-else-if="filter.type === 'cascader'" ref="cascader" :show-all-levels="false" :props="filter.optionProps" :options="filter.options" v-model="filter.value"   :style="filter.style"
                       @change="doQuery(true)" expand-trigger="hover" collapse-tags filterable
                       popper-class="ticket_ccCascader" separator="/"/>
          <el-row v-else-if="filter.type==='radio'" :style="filter.style">
            <el-radio v-model="filter.value" v-for="op in filter.options" :key="op.value" :label="op.value" @change="filter.change">{{op.label}}</el-radio>
          </el-row>
          <el-row v-else-if="filter.type===''" :style="filter.style">{{filter.label}}</el-row>
        </el-col>
        <el-button v-if="!panelData.omitSearch" type="primary" class="search-btn-blue" @click='doQuery(true)' size="mini">查询</el-button>
        <div v-if="filter.type.indexOf('radioExtra') > -1" :style="getFilterBarStyleExtra()" v-for="filter in panelData.filterForm" :key="filter.label">
          <el-radio-group v-model="filter.value" :style="filter.style"
                          @change="filter.changeBack?filter.changeBack(filter.value):doQuery(true)" size="small">
            <el-radio-button style="width: auto;" v-for="op in filter.options" :label="op[filter.props.value]" :key="op[filter.props.value]">{{op[filter.props.label]}}</el-radio-button>
          </el-radio-group>
        </div>
      </el-col>

      <!-- start************ 主显示区域 *************** -->
      <!-- 功能按钮区域 -->
      <el-col v-if="panelData.buttons && panelData.buttons.length>0" :class="getPanelMainButtonAreaClass()">
        <el-col style="width: 100%;display: flex;align-content: space-between;padding: 0 24px;border-bottom: 1px solid #EFEFEF;">
          <span v-if="panelData.tableTitle" style="height: 48px;line-height: 48px;width: fit-content;white-space: nowrap;font-size: 14px;">{{panelData.tableTitle}}</span>
          <el-col> </el-col>
          <el-col style="width: fit-content;display: flex;" class="tool-button">
            <el-button v-if="btn.handleIndex>=-1" :id="btn.id" type="text" v-for="btn in panelData.buttons" :key="btn.label" :icon="btn.icon" class="tool-icon-btn"
                       :style="btn.style" @click="btnClick(btn.type, btn)">{{btn.label}}</el-button>
          </el-col>
        </el-col>
      </el-col>
      <!-- 数据展示区域 -->
      <el-col :style="getPanelMainDataAreaStyle()">
        <!-- 通用单列表（带翻页） -->
        <el-col v-if="panelData.tableProps && panelData.tableProps.length > 0"
                style="height: 100%" class="table">
          <el-table :data="panelData.transData?panelData.transData:tableData" height="98%" ref="tableList"
                    class="common-panel-table" border fit
                    :row-class-name="getRowClass" :cell-style="cellStyle"
                    @selection-change="handleSelectionChange">
            <el-table-column v-if="panelData.tableCheck" type="selection" width="40"></el-table-column>
            <el-table-column type="index" label="序号" width="50"/>
            <el-table-column v-for="(item,i) in panelData.tableProps" :key="i"
                      v-if="!item.hasOwnProperty('show') || (item.hasOwnProperty('show') && item.show)"
                      :prop="item.prop" :label="item.label" :width="item.width" :sortable="item.sortable">

              <template slot-scope="scope">
                <el-image v-if="item.prop === 'user_img'" :key="scope.row['user_code']" :src="getImgUrl(scope.row['user_code'])"
                          fit="fill" style="width:48px;height:60px"
                          @click="showImageDialog(getImgUrl(scope.row['user_code']))">
                  <div slot="error" class="image-slot block">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <!-- start 处理特殊表格字段 (此处v-if仅使用一个，若要增加其他显示内容，在此区域end后添加再v-if) -->
                <span v-if="item.prop=== 'COLOR'" :style="getTableItemColor(scope.row.COLOR)">11111</span>
                <el-button v-else-if="item.prop === 'warn-replay'" icon="zy-icon-video-play" circle style="width: 24px;height: 24px;padding-top: 5px;padding-left: 5px;" @click="item.handle(scope.row)"/>
                <span v-else-if="item.prop==='data_type'">{{arr[parseInt(scope.row.data_type)]}}</span>
                <el-tag v-else-if="item.prop==='level'" disable-transitions :type="scope.row[item.prop] === 1 ? 'danger' : scope.row[item.prop] === 2 ? 'warning' : 'primary'" >{{scope.row[item.prop]+'级告警'}}</el-tag>
                <el-tag v-else-if="item.prop==='alarm_status'" :type="typeChange(scope.row[item.prop])">{{scope.row[item.prop]}}</el-tag>
                <el-link v-else-if="item.hasOwnProperty('click')" style="color: #3079D8" @click="item.click(scope.row)">{{scope.row[item.prop]}}</el-link>
                <span v-else-if="(item.prop==='status' || item.prop==='sex' || item.prop==='nucleic' || item.prop==='antibody' || item.prop==='online' || item.prop==='asStatus' || item.prop==='CHARGEMETHOD' || item.prop==='available' || item.prop==='AUTOCONTROL') && item.strList && item.strList.length>0">{{item.strList[scope.row[item.prop]]?item.strList[scope.row[item.prop]]:item.strList[0]}}</span>
                <span v-else-if="(item.prop==='status' || item.prop==='sex' || item.prop==='nucleic' || item.prop==='antibody' || item.prop==='online' || item.prop==='asStatus' || item.prop==='CHARGEMETHOD' || item.prop==='available' || item.prop==='delFlag') && item.strList && item.strList.length>0">{{item.strList[scope.row[item.prop]]?item.strList[scope.row[item.prop]]:item.strList[0]}}</span>
                <span v-else>{{scope.row[item.prop]}}</span>
                <!-- <el-button v-if="(item.icon)" type="text" :icon="item.icon" @click="btnClick(handleType.type,scope.row)"/> -->
                <!-- end 处理特殊表格字段 -->
              </template>
            </el-table-column>
            <el-table-column v-if="handleButtons.length>0" :width="handleButtons.length * 60" label="操作">
              <template slot-scope="scope">
                <el-tooltip v-for="handleType in handleButtons" v-if="handleType" :key="handleType.label" :content="handleType.label" class="item" effect="dark" placement="top-start">
                  <div class="table-button">
                    <el-button type="text" v-if="handleType.type&&handleType.handleIndex>-1" :icon="handleType.icon" @click="btnClick(handleType.type,scope.row)"
                               :disabled="handleType.hasOwnProperty('disabledKey') && scope.row[handleType.disabledKey] === 1" />
                    <el-button type="text" v-else-if="handleType.text&&handleType.handleIndex>-10&&(!handleType.hasOwnProperty('showFlag')||(handleType.hasOwnProperty('showFlag')&&scope.row[handleType.showFlag]===1))" :icon="handleType.icon" @click="btnClick(handleType.type,scope.row)"
                    />
                    <el-button type="text" style="color: #3079D8;" v-else-if="handleType.text&&handleType.handleIndex>-10&&(!handleType.hasOwnProperty('showFlag')||(handleType.hasOwnProperty('showFlag')&&scope.row[handleType.showFlag]===1))" @click="btnClick(handleType.type,scope.row)"
                    >{{handleType.label}}</el-button>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style='height:32px' @current-change="handlePageChange" @size-change="handleSizeChange"
                         :current-page='currPageNo' :page-size="pageSize" :total="total"
                         layout="total, sizes, prev, pager, next, jumper" :page-sizes="[18,36,54,72,90]"
                         background/>
        </el-col>
        <!-- 空白页 -->
        <el-col v-if="panelData.methods && typeof panelData.methods.add==='function' && tableData.length===0 && !panelData.dialogs.add_edit.isRefreshTree" style="height: 100%;align-items: center;padding-top: 200px">
          <el-col style="width: 100%;"><i :class="panelData.noneIcon" style="font-size: 50px;color: #ffd974"/></el-col>
          <el-col style="width: 100%">
            <span style="width: 100%;font-size: small;color: #999999;">还没有{{(panelData.dialogs)?panelData.dialogs.add_edit.title:'信息'}}</span>
          </el-col>
          <span style="width: 100%;font-size: small;color: #999999;">
            快去 <el-link :underline="false" style="color: #0acc92" @click="btnClick('add')">新增</el-link> 看看吧
          </span>
        </el-col>
        <!--多页面、多级标题列表 定制面板-->
      </el-col>
      <!-- end************ 主显示区域 *************** -->
    </el-main>
    </el-row>
    <!-- start************ 弹窗区域 *************** -->
    <!-- 抽屉 -->
    <el-drawer :append-to-body="true" :title="drawerTitle" :visible.sync="drawerVisible"
               :before-close="handleClose" :show-close="false" :size="drawerWidth">
      <template slot="title">
        <span style="line-height: 50px;align-items: center;width: 100%;display: inline-flex;">
        <el-button class="drawer-close-button" type="primary" icon="zy-icon-arrow-right" @click="drawerVisible = false"/>
        <span style="background: #F8F8F8;line-height: 50px;text-align: center;width: 100%">
          {{drawerTitle}}
        </span>
        </span>
      </template>
      <common-dialog :dialog-data="currDialog" :form-data="currFormData" :key="timeStamp" @closeDialog="drawerClose" @closeQuery="closeQuery()"
                     style="height: 100%;"/>
    </el-drawer>

    <!-- 弹窗 -->
    <el-dialog class="common-dialog" :append-to-body="true" :close-on-click-modal="false" :width="currDialogWidth" center
               :title="currDialogTitle" :visible.sync="dialogVisible" :before-close="handleClose">
      <common-dialog :dialog-data="currDialog" :form-data="currFormData" :key="timeStamp" @closeDialog="dialogClose" @closeQuery="closeQuery"/>
    </el-dialog>
    <el-dialog class="common-dialog" :append-to-body="true" :close-on-click-modal="false" :width="currDialogWidth" center
               :title="currDialogTitle" :visible.sync="dialogVisibleModel" :before-close="handleClose">
      <common-dialog :dialog-data="currDialog" :form-data="currFormData" :key="timeStamp" @closeDialog="dialogClose" @closeQuery="closeQuery()"/>
    </el-dialog>
    <el-dialog :append-to-body="true" :close-on-click-modal="false" title="信息导入进度" :visible.sync="importVisible" width="360px" center :show-close="false">
      <el-progress :percentage="importPercentage"
                   type="circle" :stroke-width="26"/>
    </el-dialog>
    <el-dialog :append-to-body="true" :close-on-click-modal="false" title="查看图片" :visible.sync="imgDialogVisible" width="600px" center top="6vh" :before-close="handleClose">
      <el-image :src="dialogImageSrc"/>
    </el-dialog>
    <!-- end************ 弹窗区域 *************** -->
  </el-container>
</template>

<script>
import {Message} from "element-ui"
import CommonDialog from "../dialog/CommonDialog";
import * as axios from "axios";

// 引入xlsx
let XLSX = require('xlsx');

export default {
  name: "CommonPanel",
  components: {CommonDialog},
  props: ['panelData'],
  data() {
    return {
      filterName: '',
      treeData: [],
      selNode: null,
      expandKeys: [],
      treeLabel: '',
      isNodeEditing: false,
      tableData: [],
      panelTreeData: [],
      multipleSelection: [],
      roleSelection: [],
      currPageNo: 1,
      pageSize: this.GlobalConfig.PAGE_SIZE_18,
      total: 0,
      drawerVisible: false,
      drawerTitle: '',
      drawerWidth: '30%',
      dialogVisible: false,
      isRefreshTree: false,
      dialogVisibleModel: false,
      dialogImageSrc: '',
      imgDialogVisible: false,
      handleButtons: [],
      treeMenuVisible: [],
      preClickMenuId: -1,
      mousePoint: {x: 0, y: 0},
      timeStamp: new Date().getTime(),
      currDialogTitle: '',
      currDialogWidth: '700px',
      currDialog: {},
      currFormData: {},
      param: [],
      fullscreenLoading: false,
      imFile: '',
      progressIndex: 0,
      importLength: 0,
      divideLen: 10,
      importPercentage: 0,
      importVisible: false,
      remote: false,
      assetsIdArray: [],
      delFlag: [],
      arr: ['', '遥信', '遥测', '累积量'],
      inputStore: '',
      activeIndex: 1,
      buttonFlag: '', // 编辑按钮是否可选
      userImageMap: new Map(),
      treeSelection: [],
      selPermissions: [],
      roleAssignDialog: false,
      trailDialog: false,
      registerDialog: false,
      trailInfo: '',
      exportData: {},
      checkedKey: '',
      mediaId: '1'
    }
  },
  created() {
    this.GlobalData.currentSystemId = this.systemId;
    let treeValue = '0';
    if (this.panelData.treeValue) {
      treeValue = this.panelData.treeValue;
    }
    if(this.panelData.hasOwnProperty('beforeQueryTree') && this.panelData.beforeQueryTree) {
      this.$emit('doBefore', treeValue);
      if (this.panelData.hasTree) {
        this.treeLabel = this.panelData.treeProps.label;
      }
    }else if (this.panelData.hasTree) {
      this.treeLabel = this.panelData.treeProps.label;
      this.getTree(treeValue);
    } else {
      this.doQuery();
    }
    this.getHandleButtons();
    if (this.panelData.filterForm) {
      this.panelData.filterForm.forEach((select) => {
        if ((select.type === 'select' || select.type === 'cascader') && typeof select.method === 'function') {
          select.method().then(res => {
            if (select.options.length === 0) select.options = res.data;
            else if(select.options.length === 1) select.options.push(...res.data);
          })
        }else if (select.type === 'input') {
          select.value = '';
        }
      })
    }
    if(typeof this.panelData.typeBack === 'string' && this.panelData.typeBack === 'changeable') {
      this.panelData.typeBack = this.doQuery;
    }
  },
  methods: {
    menuSelect(val) {
      this.mediaId = val
      if(this.panelData.hasOwnProperty('energyItemClick') && typeof this.panelData.energyItemClick === 'function') {
        if (this.panelData.hasTree) {
          this.panelData.energyItemClick(val);
          setTimeout(() => {
            this.getTree(val)
          }, 50);
          this.treeLabel = this.panelData.treeProps.label;
        }
      } else {
        this.doQuery()
      }
    },
    handleCheckChange(checked) {
      let idList = this.panelData.extraData.idList
      let nameList = this.panelData.extraData.nameList
      if(checked.type === '2') {
        if(idList.indexOf(checked.id) <= -1) {
          idList.push(checked.id)
          nameList.push(checked.name)
        }else {
          idList.splice(idList.indexOf(checked.id), 1)
          nameList.splice(nameList.indexOf(checked.name), 1)
        }
      }
    },
    formatCC() {
      let htmladd = document.createElement("bottom");
      htmladd.innerHTML = "确认";
      htmladd.className = "htmladd";
      htmladd.style.cssText =
        "cursor: pointer;position: absolute;bottom: -35px;height: 35px;line-height:35px;width:100%;background:#fff;text-align: center;color:#606266;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);";
      let that = this;
      let eLl = document.querySelectorAll(".el-popper.el-cascader__dropdown.ticket_ccCascader");
      if (eLl.length > 0 && eLl.length === 1) {
        let el = eLl[0];
        if (!el.querySelector(".htmladd")) {
          el.appendChild(htmladd);
          let bo = el.querySelectorAll(".htmladd")[0];
          bo.onclick = function () {
            that.$refs.cascader[0].dropDownVisible = false
          }
        }
      }
    },
    getTreeSelection(sData, pList) { // 设置权限初始选中状态
      let that = this;
      sData.forEach((perm) => {
        if(perm.children.length > 0) {
          that.getTreeSelection(perm.children, pList);
        }else{
          if(pList.indexOf(perm.id) > -1) {
            that.treeSelection.push(perm.id);
          }
        }
      });
    },
    getPanelAsideClass() {
      let classStr = '';
      classStr = 'common-panel-aside';
      return classStr;
    },
    getPanelTreeClass() {
      let classStr = '';
      classStr = this.getTreeBack() + ' doc-tree';
      return classStr;
    },
    getPanelMainClass() {
      let classStr = '';
      classStr = ((this.panelData.buttons && this.panelData.buttons.length === 0) ? ('el-main-no-tool') : ('el-main'));
      if(this.panelData.hasTree) classStr += ' epidemic-panel-main';
      return classStr;
    },
    getPanelMainStyle() {
      let styleStr = '';
      return styleStr;
    },
    getFilterBarStyle() {
      return 'align-items: center;display: inline-flex;width: fit-content;';
    },
    getFilterBarStyleExtra() {
      return 'height: 32px;width: calc(95% - 326px);margin-left: 2%;';
    },
    getFilterButtonStyle() {
      return 'height: 32px; font-size: 12px;padding-top: 10px;';
    },
    getFilterInputClass() {
      return 'tt-input';
    },
    getPanelMainButtonAreaClass() {
      let classStr = '';
      classStr = 'doc-button-bar';
      classStr += ' epidemic-panel-main-button-area';
      return classStr;
    },
    getPanelMainDataAreaStyle() {
      let height = 20;
      if (this.panelData.filterForm && this.panelData.filterForm.length > 0) {
        height += 49;
      }
      if (this.panelData.buttons && this.panelData.buttons.length > 0) {
        height += 48;
      }
      return 'height: calc(100% - ' + height + 'px);';
    },
    getTreeBack() {
      return 'light-blue-back-tree';
    },
    updateAbnormStatus(clickItem) {
      if(clickItem === null) {
        let idArr = [];
        if (this.multipleSelection.length < 1) {
          Message.warning('请勾选一行进行编辑！');
        }else if(this.multipleSelection.length >= 1) {
          for(let i = 0; i < this.multipleSelection.length; i++) {
            idArr.push(this.multipleSelection[i].id)
          }
          let aParam = {'id': idArr.toString(), 'status': 1}
          this.panelData.methods.Abnorm(aParam).then(res => {
            Message.success(res.message)
            this.doQuery();
          })
        }
      }else if (typeof clickItem === 'object') {
        let Param = clickItem;
        Param = {'id': clickItem.id, 'status': 1}
        this.panelData.methods.Abnorm(Param).then(res => {
          if(res.code === 200) Message.success(res.message);
          this.delCheckLastPage([clickItem]);
          this.doQuery();
        })
      }
    },
    onKeyPress(evt) {
      if(evt.key === 'Enter') {
        this.doQuery(true);
      }
    },
    inputChange(evt, val) {
      if(this.inputStore === val) {
        return;
      }else {
        this.inputStore = val;
      }
      this.panelData.filterForm.forEach((filter) => {
        if (filter.type === 'input') {
          if (this.panelData.dialogs.add_edit.table.selectShow === true) {
            if (filter.value && filter.value.length > 16) {
              filter.value = filter.value.substring(0, 16);
            }
          } else {
            if (filter.value && filter.value.length > this.GlobalConfig.INPUT_SIZE) {
              filter.value = filter.value.substring(0, this.GlobalConfig.INPUT_SIZE);
            }
          }
        }
      })
      this.doQuery(true);
    },
    getHandleButtons() {
      this.handleButtons = [];
      if (this.panelData.buttons && this.panelData.buttons.length > 0) {
        this.panelData.buttons.forEach((hBtn) => {
          if (hBtn.handleIndex > -1) {
            this.handleButtons[hBtn.handleIndex] = hBtn;
          }else if (hBtn.handleIndex < -1) {
            this.handleButtons.push(hBtn);
          }
        });
      }
    },
    getTree(value) {
      this.panelData.treeMethod(value).then(res => {
        this.treeData = res.data;
        console.log('设备树', this.treeData);
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          if(this.panelData.extraData && this.panelData.extraData.treeNode) {
            this.panelData.extraData.treeNode = this.selNode
          }
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
          })
        }
      })
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childList && pNode.childList.length > 0) {
        leafNode = this.getLeafNode(pNode.childList[0]);
      }else if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }else if (pNode.children && pNode.children.length > 0) {
        leafNode = this.getLeafNode(pNode.children[0]);
      }
      return leafNode;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data[this.treeLabel].indexOf(value) !== -1;
    },
    // 设置选中的树节点
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    handleCheckAllChange(val, method) {
      if(val === true) {
        let pMethods = this.panelData.methods;
        method(this.selNode[pMethods.query_id]).then(res => {
          Message.success(res.message)
        })
      }
    },
    handleNodeClick(cNode, node) {
      if(this.selNode === '呵呵') {
        node.expanded = !node.expanded;
      }
      this.selNode = cNode;
      this.setNodeLabel();
      if(this.panelData.dialogs && this.panelData.dialogs.add_edit && this.panelData.dialogs.add_edit.node) {
        this.panelData.dialogs.add_edit.node = this.selNode.id
      }
      if(this.panelData.extraData && this.panelData.extraData.nodeSeacrh) {
        this.panelData.extraData.treeNode = this.selNode.id
        this.panelData.extraData.queryMethod(this.panelData.extraData.treeNode).then(res => {
          this.panelData.extraData.form = res.data
        })
      }
      this.doQuery(true);
    },
    setNodeLabel() {
      let _self = this;
      if(this.panelData.filterForm && this.panelData.filterForm.length > 0) {
        this.panelData.filterForm.forEach((filterItem) => {
          if(filterItem.showTreeNode) {
            if(this.selNode.type === filterItem.showTreeNode.type) {
              filterItem.value = this.selNode[this.panelData.treeProps.label];
              this.remote = true;
              if(typeof filterItem.method === 'function') {
                filterItem.method(this.selNode.id).then(res => {
                  this.panelData.extraData.sensorTableData = res.data;
                });
              }
            } else {
              filterItem.value = filterItem.showTreeNode.warning;
              this.remote = false;
            }
          }else if(filterItem.type === 'label') {
            filterItem.value = this.selNode[this.panelData.treeProps.label];
          }
        })
      }
    },
    doQuery(isClick = false, isNeedSel = false) {
      if(typeof isClick === 'boolean' && isClick) this.currPageNo = 1;
      if(isNeedSel && !this.selNode) return;
      let params = {
        page: this.currPageNo,
        rows: this.pageSize
      };
      if (this.panelData.hasMenu) {
        this.$set(params, 'mediaId', this.mediaId);
      }
      let isQuit = false;
      let pMethods = this.panelData.methods;
      if(this.selNode) {
        if(pMethods && pMethods.query_prop) {
          let queryProp = pMethods.query_prop;
          let queryId = pMethods.query_id;
          this.$set(params, queryProp, this.selNode[queryId]);
          if(pMethods.query_prop1) {
            let queryProp1 = pMethods.query_prop1;
            let queryID = pMethods.query_ID;
            this.$set(params, queryProp1, this.selNode[queryID]);
          }
        }else {
          this.$set(params, 'id', this.selNode.id);
        }
        if(pMethods && pMethods.query_type) {
          let queryType = pMethods.query_type;
          this.$set(params, 'type', this.selNode[queryType]);
        }
        if(pMethods && pMethods.query_Type) {
          let queryType = pMethods.query_Type;
          this.$set(params, 'node_type', this.selNode[queryType]);
        }
        this.$set(params, 'nodeType', this.selNode.type);
      }
      if(pMethods && pMethods.searchType) {
        let searchType = pMethods.searchType;
        this.$set(params, 'searchType', searchType);
      }
      if(this.panelData && this.panelData.queryId) {
        this.$set(params, 'id', this.panelData.queryId);
      }
      if(this.panelData.filterForm) {
        this.panelData.filterForm.forEach((fItem) => {
          if(fItem.value || fItem.value === 0) {
            if(fItem.type === 'date' && typeof fItem.value.Format === 'function') {
              this.$set(params, fItem.prop, fItem.value.Format('yyyy-MM-dd'));
            }else if(fItem.type === 'month' && typeof fItem.value.Format === 'function') {
              this.$set(params, fItem.prop, fItem.value.Format('yyyy-MM'));
            }else if(fItem.type === 'year' && typeof fItem.value.Format === 'function') {
              this.$set(params, fItem.prop, fItem.value.Format('yyyy'));
            }else if(fItem.required && fItem.value.length === 0) {
              Message.warning(fItem.required);
              isQuit = true;
            }else if(fItem.type === 'cascader') {
              if(fItem.value === '-1') {
                this.$set(params, fItem.prop, '-1');
              }else {
                console.log(fItem.value)
                this.$set(params, fItem.prop, fItem.value[fItem.value.length - 1]);
              }
            }else {
              this.$set(params, fItem.prop, fItem.value);
            }
          }else if(fItem.prop) {
            this.$set(params, fItem.prop, '');
          }
        })
      }
      if(isQuit) return;
      if(typeof this.panelData.queryMethod === 'function') {
        this.panelData.queryMethod(params).then(res => {
          this.resultHandle(res.data.rows);
          this.tableData = res.data.rows;
          this.total = res.data.total;
        });
      }
    },
    resultHandle(result) {
      if(this.panelData.filterForm && this.panelData.filterForm.length > 0) {
        this.panelData.filterForm.forEach((filterData) => {
          if(filterData.showInTable) {
            result.forEach((eachData) => {
              if(eachData[filterData.prop] !== undefined) {
                if(filterData.options) this.$set(eachData, filterData.prop, this.getOptionByValue(filterData.options, eachData[filterData.prop]));
                else if(filterData.label !== '') this.$set(eachData, filterData.prop, eachData[filterData.prop] + filterData.label);
              }
            });
          }
        })
      }
    },
    getOptionByValue(opts, val) {
      let option = '';
      opts.forEach((opt) => {
        if(opt.value === val || opt.value === val + '') {
          option = opt.label;
        }
      });
      return option;
    },
    getRowClass(val) {
      if(val.row.BUILD_ID) {
        if(val.row.BUILD_ID === this.selNode.id) {
          return 'parent-table-row';
        }
      }else {
        return 'common-table-row';
      }
    },
    cellStyle(row) {
      if (row.column.property === "7" || row.column.property === "8" || row.column.property === "12") {
        return row.row[row.column.property + "limitFlag"] === 1 ? 'color:green' : 'color:red'
      }
    },
    getTableItemColor(color) {
      return 'color: ' + color + ';background-color: ' + color + ';';
    },
    btnClick(type, clickItem = null, isNodeEdit = false) {
      if(this.$refs.treeMenuPop && this.$refs.treeMenuPop.showPopper) this.$refs.treeMenuPop.doClose();
      switch (type) {
        case 'add':
          if(isNodeEdit) {
            this.isNodeEditing = isNodeEdit;
            this.treeData.splice(0, 0, {id: -1, name: '新建模板', childList: []});
            this.$nextTick(function () {
              this.setTreeCurrent(-1, 1);
            })
            return;
          }
          this.doAddOrEdit(null);
          break;
        case 'edit':
          if(isNodeEdit) {
            this.isNodeEditing = isNodeEdit;
            return;
          }
          if(clickItem === null) {
            if(this.multipleSelection.length > 1) {
              Message.warning('无法对多行进行编辑，请勾选一行！');
              return;
            }else if(this.multipleSelection.length < 1) {
              Message.warning('请勾选一行进行编辑！');
              return;
            } else {
              clickItem = this.multipleSelection[0];
              if(this.panelData.dialogs.add_edit.node) {
                this.$set(clickItem, 'USER_ID', this.panelData.dialogs.add_edit.node)
              }
            }
            this.doAddOrEdit(clickItem);
          }else {
            this.doAddOrEdit(clickItem);
          }
          break;
        case 'submit':
          this.submit(clickItem);
          break;
        case 'del':
          this.doDel(clickItem);
          break;
        case 'refresh':
          this.doQuery(true);
          break;
        case 'roleAssign':
          this.roleAssign(clickItem);
          break;
        case 'add_tree_node':
          this.doAddOrEdit(null, true);
          break;
        case 'edit_tree_node':
          this.doAddOrEdit(this.selNode, true);
          break;
        case 'del_tree_node':
          this.doDel(this.selNode, true);
          break;
        case 'export':
          // TODO 导出
          this.toExcel()
          break;
        case 'exportTemplate':
          // TODO 导出
          this.toExcelModel();
          break;
        case 'Abnorm':
          // TODO 报警
          this.updateAbnormStatus(clickItem);
          break;
        case 'upload':
          this.panelData.methods.upload();
          break;
        case 'download':
          this.doDownload(clickItem);
          break;
        case 'downloadFile':
          this.doDownloadFile(clickItem);
          break;
        case 'toPdf':
          this.toPdf(clickItem);
          break;
        case 'resetPsw':
          if(clickItem === null) {
            if(this.multipleSelection.length > 1) {
              Message.warning('无法对多行操作，请勾选一行！');
              return;
            }else if(this.multipleSelection.length < 1) {
              Message.warning('请勾选一行进行操作！');
              return;
            }
            clickItem = this.multipleSelection[0];
            this.resetPsw(clickItem);
          }else {
            this.resetPsw(clickItem);
          }
          break;
        case 'updateRows':
          if(clickItem === null) {
            if(this.multipleSelection.length < 1) {
              Message.warning('请勾选一行进行操作！');
              return;
            } else if (this.multipleSelection.length === 1) {
              clickItem = this.multipleSelection[0];
            } else {
              clickItem = null;
            }
            this.updateRows(clickItem);
          }else {
            console.log(clickItem)
            this.updateRows(clickItem);
          }
          break;
        case 'function':
          clickItem.method().then(res => {
            if(res.code === 200) {
              Message.success(res.message)
            }
          })
          break
        default:
          Message.warning('未知按钮类型: ' + type);
          break;
      }
    },
    roleAssign(val) {
      console.log(val);
      if(val) {
        this.roleSelection = [val];
        this.roleAssignDialog = true;
      }else if(this.multipleSelection.length === 0) {
        Message.warning('请选择要分配的员工');
      }else {
        this.roleSelection = this.multipleSelection;
        this.roleAssignDialog = true;
      }
    },
    showImageDialog(val) {
      this.dialogImageSrc = val;
      this.imgDialogVisible = true;
    },
    closeQuery(data, addData) {
      if(data === null || data === undefined) {
        if(this.isRefreshTree) this.getTree();
        else this.doQuery(true);
      } else {
        this.tableData = data
        this.exportData = addData
      }
    },
    dialogClose (params) {
      this.dialogVisible = false;
      this.dialogVisibleModel = false
      this.doQuery()
    },
    drawerClose() {
      this.drawerVisible = false;
      this.doQuery()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.buttonFlag = this.multipleSelection[0];
    },
    handlePageChange(pageNo) {
      this.currPageNo = pageNo;
      this.doQuery();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.doQuery();
    },
    handleClose(done) {
      done();
    },
    doAddOrEdit(clickItem, isTreeNode = false) {
      if(isTreeNode) {
        this.currDialogTitle = this.panelData.dialogs.add_edit_node.title;
        this.currDialogWidth = this.panelData.dialogs.add_edit_node.width;
        this.currDialog = this.panelData.dialogs.add_edit_node;
        if(clickItem === null) {
          this.currDialog.confirmMethod = this.panelData.methods.add_node;
          this.currDialog.editFlag = false
        }else {
          this.currDialog.confirmMethod = this.panelData.methods.edit_node;
          this.currDialog.editFlag = true
        }
      }else {
        this.currDialogTitle = this.panelData.dialogs.add_edit.title;
        this.currDialogWidth = this.panelData.dialogs.add_edit.width;
        this.currDialog = this.panelData.dialogs.add_edit;
        if(clickItem === null) {
          this.currDialog.confirmMethod = this.panelData.methods.add;
          this.currDialog.editFlag = false
        }else {
          this.currDialog.confirmMethod = this.panelData.methods.edit;
          this.currDialog.editFlag = true
        }
      }
      this.isRefreshTree = this.currDialog.isRefreshTree;
      if(clickItem && clickItem.hasOwnProperty('parentId')) {
        this.$set(clickItem, 'parent_id', clickItem.parentId);
      }
      if(this.currDialog.table) {
        if(this.currDialog.table.hasOwnProperty('assetsTable')) {
          this.currDialog.table.assetsTable = []
          this.currDialog.table.showData = []
          this.currDialog.table.arr = []
        }
      }
      this.currFormData = clickItem;
      this.timeStamp = new Date().getTime();
      this.dialogVisible = true;
    },
    doDel(isMulti, isTreeNode = false) {
      if(isMulti === null) {
        if(this.multipleSelection.length === 0) {
          Message.warning('未选择');
        } else {
          console.log(this.multipleSelection);
          this.$confirm('确认删除已选' + this.panelData.dialogs.add_edit.title + '？')
            .then(_ => {
              let pMethods = this.panelData.methods;
              let delProp = pMethods.del_prop;
              let params = {};
              // 删除前先清空数组
              let delarr = [];
              for (let i = 0; i < this.multipleSelection.length; i++) { delarr.push(this.multipleSelection[i][delProp]); }
              this.$set(params, delProp, delarr.toString());
              this.panelData.methods.del(params).then(res => {
                Message.success(res.message + '（勾选）');
                this.delCheckLastPage(this.multipleSelection);
                this.doQuery();
              })
            });
        }
      }else if(typeof isMulti === 'object') {
        if(isTreeNode) {
          if((isMulti.hasOwnProperty('children') && isMulti.children.length > 0) || (isMulti.hasOwnProperty('childList') && isMulti.childList.length > 0)) {
            Message.warning('当前' + this.panelData.dialogs.add_edit_node.title + '包含子节点，请先删除下属所有' + this.panelData.dialogs.add_edit_node.title + '再执行此操作！');
          }else {
            this.$confirm('确认删除当前' + this.panelData.dialogs.add_edit_node.title + '？')
              .then(_ => {
                this.panelData.methods.del_node(isMulti).then(res => {
                  if(res.code === 200) Message.success(res.message);
                  this.getTree();
                })
              });
          }
          return;
        }
        this.$confirm('确认删除当前' + this.panelData.dialogs.add_edit.title + '？')
          .then(_ => {
            let param = isMulti;
            let pMethods = this.panelData.methods;
            let delProp = pMethods.del_prop;
            if(pMethods.delKV) {
              param = isMulti.id
            }else if(isMulti.id) {
              this.$set(param, delProp, isMulti.id)
            }
            if(isMulti.BUILD_ID) {
              param = {"BUILD_ID": isMulti.BUILD_ID};
            }
            this.panelData.methods.del(param).then(res => {
              if(res.code === 200) Message.success(res.message);
              if(this.panelData.dialogs.add_edit.isRefreshTree) {
                this.getTree();
                this.doQuery();
              } else {
                this.delCheckLastPage([isMulti]);
                this.doQuery()
              }
            })
          });
      }
    },
    // 判断处理最后一页全部删除
    delCheckLastPage(delList) {
      if(this.currPageNo > 1) {
        let maxPageNo = Math.ceil(this.total / this.pageSize); // 最大页码
        let lastPageLen = this.total - (maxPageNo - 1) * this.pageSize; // 最后一页数据数量
        let isLastPage = this.currPageNo === maxPageNo; // 当前是否为最后一页
        let isAllSelected = (delList.length === lastPageLen); // 是否全选最后一页
        if(isLastPage && isAllSelected) {
          this.currPageNo--;
        }
        this.doQuery();
      }
    },
    toExcel() {
      this.param = [];
      if(this.panelData.methods.excelAPI) {
        if (this.panelData.hasOwnProperty('dialogs') && this.panelData.dialogs.search_detail) {
          for (var item in this.exportData) {
            // console.log(this.exportData[item])
            this.param.push(this.exportData[item])
          }
        } else {
          this.panelData.filterForm.forEach((filter) => {
            if (filter.value && filter.value.Format) {
              this.param.push(filter.value.Format('yyyy-MM-dd'));
            } else if (filter.type !== 'label' && filter.type !== 'button') {
              this.param.push(filter.value)
            }
          })
        }
        if (this.panelData.methods.query_id) {
          let queryId = this.panelData.methods.query_id;
          this.param.push(this.selNode[queryId]);
        }
        let paramStr;
        let EPIDEMIC_EXCEL_API = ['/sys_user', '/tempManage'];
        if (this.panelData.methods.excelAPI === 'energyUser/exportUser') {
          this.param.push('flag')
          paramStr = '/api/service-energy/' + this.panelData.methods.excelAPI + this.panelData.methods.excelUrl + '?searchData=' + this.param.join('_');
        } else if (EPIDEMIC_EXCEL_API.indexOf(this.panelData.methods.excelAPI) > -1) {
          if (this.panelData.methods.excelAPI === '/tempManage') {
            let statusValue = this.param.splice(1, 1);
            this.param.push(statusValue[0]);
          }
          paramStr = '/api/service-epidemic' + this.panelData.methods.excelAPI + '/exportExcel?searchData=' + this.param.join('_');
        } else if (this.panelData.methods.excelAPI === '/user') {
          paramStr = '/api/service-security' + this.panelData.methods.excelAPI + '/exportExcel?searchData=' + this.param.join('_');
        } else if (this.panelData.methods.excelAPI === '/outside') {
          paramStr = '/api/service-attendance' + this.panelData.methods.excelAPI + '/exportExcel?searchData=' + this.param.join('_');
        } else if (this.panelData.methods.excelAPI.startsWith('/assets')) {
          paramStr = '/api/service-assets' + this.panelData.methods.excelAPI + '/exportExcel?searchData=' + this.param.join('_');
        } else {
          paramStr = '/api/service-energy/' + this.panelData.methods.excelAPI + '/exportExcel?searchData=' + this.param.join('_');
        }
        paramStr += '_' + sessionStorage.getItem('token');
        window.open(axios.defaults.baseURL + paramStr);
      }
    },
    toExcelModel() {
      this.currDialogTitle = this.panelData.excelDialogs.add_edit.title;
      this.currDialogWidth = this.panelData.excelDialogs.add_edit.width;
      this.currDialog = this.panelData.excelDialogs.add_edit;
      this.timeStamp = new Date().getTime()
      this.dialogVisibleModel = true;
    },
    // 点击下载模板按钮
    doDownload(clickItem) {
      if(clickItem === null) {
        if(this.multipleSelection.length === 0) {
          Message.warning('未选择');
        } else {
          this.panelData.methods.download(this.multipleSelection).then(res => {
            // 构造一个blob对象来处理数据
            const blob = new Blob([res.data])
            const fileName = (this.multipleSelection.length === 1) ? this.multipleSelection[0].fileName : ('下载' + (new Date().Format('yyMMddhhmmss')) + '.zip');
            this.downloadHandle(blob, fileName);
          });
        }
      } else {
        this.panelData.methods.download([clickItem]).then(res => {
          // 构造一个blob对象来处理数据
          const blob = new Blob([res.data])
          const fileName = clickItem.fileName;
          this.downloadHandle(blob, fileName);
        });
      }
    },
    downloadHandle(blob, fileName) {
      // 支持a标签download的浏览器
      if ('download' in document.createElement('a')) {
        // 创建a标签
        const link = document.createElement('a')
        // a标签添加属性
        link.download = fileName
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link)
        // 执行下载
        link.click()
        // 释放url
        URL.revokeObjectURL(link.href)
        // 释放标签
        document.body.removeChild(link)
        // 其他浏览器
      } else {
        navigator.msSaveBlob(blob, fileName);
      }
    },
    doDownloadFile(clickItem) {
      window.open(axios.defaults.baseURL + this.panelData.methods.excelAPI + '?id=' + clickItem.id)
    },
    toPdf(clickItem) {
      let routes = this.$router.resolve({name: 'PdfDetail', query: {url: axios.defaults.baseURL + this.panelData.methods.excelAPI + '?id=' + clickItem.id}});
      window.open(routes.href, "_blank");
    },
    resetPsw(val) {
      this.panelData.methods.resetPsw(val.id).then(res => {
        Message.success(res.message);
        this.doQuery(true);
      })
    },
    updateRows(clickItem) {
      this.currDialogTitle = this.panelData.dialogs.add_edit.title;
      this.currDialogWidth = this.panelData.dialogs.add_edit.width;
      this.currDialog = this.panelData.dialogs.add_edit;
      console.log(this.multipleSelection)
      if(clickItem === null) {
        clickItem = {id: ''};
        let updateProp = this.panelData.methods.update_prop;
        let delarr = [];
        for (let i = 0; i < this.multipleSelection.length; i++) { delarr.push(this.multipleSelection[i][updateProp]); }
        this.$set(clickItem, updateProp, delarr.toString());
        this.currDialog.confirmMethod = this.panelData.methods.edit;
        this.currDialog.editFlag = false
      }else {
        this.currDialog.confirmMethod = this.panelData.methods.edit;
        this.currDialog.editFlag = true
      }
      this.$set(clickItem, 'mediaId', this.mediaId)
      this.currFormData = clickItem;
      this.timeStamp = new Date().getTime();
      this.dialogVisible = true;
    }
  },
  computed: {
    systemId: function() {
      let systemId = '';
      systemId = this.$parent.$parent.$parent.systemId;
      if(!systemId) systemId = this.$parent.$parent.$parent.$parent.systemId;
      return systemId;
    },
    isEpidemic: function () {
      return (this.systemId === this.GlobalConfig.EPIDEMIC_ID);
    },
    isSecurity: function () {
      return (this.systemId === this.GlobalConfig.SECURITY_ID);
    },
    showFilterBar: function () {
      return (this.panelData.filterForm && this.panelData.filterForm.length > 0);
    }
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted () {
    this.imFile = document.getElementById('imFile');
    let that = this;
    setInterval(function() {
      document.querySelectorAll(".el-cascader-node__label").forEach(el => {
        el.onclick = function() {
          if (this.previousElementSibling) this.previousElementSibling.click();
        };
      });
    }, 1000);
    this.$nextTick(function() {
      that.formatCC();
    });
  },
  updated() {
    this.$nextTick(function() {
      this.formatCC();
    });
  }
}
</script>

<style>
  .el-drawer__header{
    padding: 0 !important;
    margin: 0 !important;
    display: inline-flex;
  }
  .common-dialog .el-dialog--center .el-dialog__body {
    text-align: initial;
    padding: 15px 25px 15px;
  }
  .el-table .common-table-row{
    height: 16px;
    line-height: 16px;
  }
  .el-table .parent-table-row{
    background: oldlace;
  }
  .doc-filter-bar ::-webkit-scrollbar {
    height: 6px !important;
    background-color: #999 !important;
  }
  .doc-filter-bar ::-webkit-scrollbar-thumb {
    background-color: #000 !important;
  }
</style>

<style scoped>
  #common-panel {
    border-top: 1px solid #f0f2f5;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .horizontal-menu{
    border: 0 !important;
    height: 48px !important;
    line-height: 48px !important;
  }
  .horizontal-menu-item{
    border: 0 !important;
    height: 48px !important;
    line-height: 48px !important;
    text-align: center;
    font-weight: bold;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .horizontal-menu-item:hover{
    color: rgba(10, 82, 255, 1) !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }
  .horizontal-menu-item.is-active{
    color: rgba(10, 82, 255, 1) !important;
    background: rgba(255, 255, 255, 0.8) !important;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 0;
  }
  .el-tree-node__expand-icon.expanded {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    margin-left: 14px;
  }
  .icon-menu-button[data-v-1137831a] {
    width: 16px;
    height: 24px;
    background: transparent;
    text-align: center;
    padding-top: 4px;
    margin-right: 16px;
  }
  .el-container{
    width: 100%;
    height: 100%;
  }
  .epidemic-panel{
    padding: 24px 24px 0 24px;
  }
  .epidemic-panel-main{
    margin-left: 0px !important;
  }
  .common-panel-aside{
    height: 100%;
    /*overflow: auto;*/
    /*padding-bottom: 50px;*/
  }
  .common-panel-sel-aside{
    height: 100%;
    overflow: hidden;
    margin: 0 1px 0 0;
    padding-bottom: 90px;
  }
  .common-panel-title-aside{
    height: 100%;
    background: white;
    overflow: hidden;
    margin: 0 1px 0 0;
    padding-bottom: 95px;
  }
  .common-panel-title-sel-aside{
    height: 100%;
    background: white;
    overflow: hidden;
    margin: 0 1px 0 0;
    padding-bottom: 135px;
  }
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  .doc-tree-title{
    display: flex;
    align-content: space-between;
    align-items: center;
    height: 45px;
    border-top: thin solid #F9F9F9;
  }
  .doc-tree-node-sel{
    display: flex;
    align-content: space-between;
    align-items: center;
    height: 40px;
    background: rgba(48,121,216,0.12);
  }
  .zy-icon-button{
    color: #333333;
    font-size: 24px;
  }
  .table-button {
  }
  .table-button .el-button--text {
    color: #4444c7;
    background: 0 0;
    padding-left: 0;
    padding-right: 0;
  }
  .table-button .el-button--text:hover {
    color: #a8a8a8;
    border-color: transparent;
    background-color: transparent;
  }
  .table-button .el-button--text:focus {
    color: #a8a8a8;
    border-color: transparent;
    background-color: transparent;
  }
  .tool-button {
  }
  .tool-button .el-button--text {
    color: #F7F7F7;
    background: 0 0;
    padding-left: 0;
    padding-right: 0;
  }
  .tool-button .el-button--text:hover {
    color: #d5d5d5;
    border-color: transparent;
    background-color: transparent;
  }
  .tool-button .el-button--text:focus {
    color: #d5d5d5;
    border-color: transparent;
    background-color: transparent;
  }
  .aside-button-bar{
    width: 36%;
  }
  .doc-tree{
    height: 100%;
    overflow: auto;
  }
  .doc-tree-sel{
    border-top: thin solid #F9F9F9;
    margin-top: 90px;
    height: 100%;
    overflow: auto;
  }
  .doc-tree-width-title{
    border-top: thin solid #F9F9F9;
    margin-top: 95px;
    height: 100%;
    overflow: auto;
  }
  .doc-tree-width-title-sel{
    border-top: thin solid #F9F9F9;
    margin-top: 135px;
    height: 100%;
    overflow: auto;
  }
  .tree-node-with-menu{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .icon-menu-button{
    width: 16px;
    height: 24px;
    background: transparent;
    text-align: center;
    padding-top: 4px;
    margin-right: 8px;
  }
  .icon-menu-button:focus, .icon-menu-button:hover  {
    color: white;
    background-color: #666666;
  }
  .el-main{
    width: calc(100% - 250px);
    height: 100%;
    overflow-y: hidden;
  }
  .el-main-notree {
    height: 100%;
    overflow-y: hidden;
  }
  .el-main-no-tool{
    height: 100%;
    margin: 0;
    overflow-y: hidden;
  }
  .el-main-has-select{
    height: 100%;
    margin: 0;
    overflow-y: hidden;
  }
  .el-main-extra{
    height: 100%;
    margin: 0;
    overflow-y: hidden;
  }
  .doc-type-select{
    width: 100%;
    height: 45px;
    background: white;
    display: flex;
    align-items: center;
    border-bottom: thin solid #C9C9C9;
  }
  .doc-type-select-energy{
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    border-bottom: thin solid #C9C9C9;
  }
  .radio-menu-button{
    font-size: 16px;
    font-weight: bold;
  }
  .doc-filter-bar{
    width: 100%;
    height: 49px;
    background-color: #ffffff;
    color: rgb(127, 127, 127);
    display: flex;
    align-items: center;
    border-bottom: 1px solid #F9F9F9;
  }
  .search-btn-yellow{
    margin-left: 12px;
    height: 36px;
    background: #ffd974;
    padding-top: 10px;
  }
  .search-btn-yellow:hover {
    color: #333333;
    border-color: transparent;
    background-color: #f9df9a;
  }
  .doc-button-bar{
    width: 100%;
    height: 48px;
    display: inline-flex;
  }
  .epidemic-panel-main-button-area{
    background-color: rgba(2, 124, 247, 0.8);
    color: #f7f7f7;
    font-size: 14px;
  }
  .tool-icon-btn{
    margin: 0 5px 0 15px;
    font-size: 14px;
  }
  .el-table{
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
  }
  .common-table-row{
    height: 14px;
    line-height: 14px;
  }
  .el-pagination{
    height: 36px;
    background: white;
    align-items: center;
    display: flex;
  }
  .drawer-close-button{
    height: 50px;
    width: 15px;
    padding-left: 5px;
    padding-right: 20px;
    border-radius: 0;
    font-size: 18px;
  }
  .el-tree {
    background-color: rgba(255, 255, 255, 0);
  }
  .el-tree >.el-tree-node {
    display: inline-block;
    min-width: 100%;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
  .inner-part {
    width: 100%;
    height: calc(100% - 49px);
    display: flex;
    flex-direction: row;
  }
  .item {
    display: inline-flex;
    width: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/panel/CommonPanel.vue